import { useState, useEffect } from 'react'
import { supabase } from '../supabase'
import './Login.css'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    // Supabase gère automatiquement le token dans le hash
    supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setReady(true)
    })
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== confirm) return setMsg({ type: 'error', text: 'Les mots de passe ne correspondent pas.' })
    if (password.length < 6) return setMsg({ type: 'error', text: 'Minimum 6 caractères.' })

    setLoading(true)
    setMsg(null)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setMsg({ type: 'error', text: error.message })
    } else {
      setMsg({ type: 'success', text: 'Mot de passe mis à jour. Vous pouvez vous connecter.' })
      setTimeout(() => { window.location.href = '/' }, 2000)
    }
    setLoading(false)
  }

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-left-deco">✦</div>
        <h1>Spa des Élèves</h1>
        <p>École Internationale du Spa</p>
        <div className="login-left-tag">Réinitialisation du mot de passe</div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <h3>Nouveau mot de passe</h3>
          <p className="login-sub">Choisissez un mot de passe sécurisé</p>

          {!ready && (
            <div className="alert alert-info">Vérification du lien en cours...</div>
          )}

          {msg && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}

          {ready && !msg?.type === 'success' && (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Nouveau mot de passe</label>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  minLength={6}
                  placeholder="6 caractères minimum"
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label>Confirmer le mot de passe</label>
                <input
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                  placeholder="••••••••"
                />
              </div>
              <button type="submit" className="btn btn-primary login-btn" disabled={loading}>
                {loading ? 'Enregistrement...' : 'Définir le mot de passe'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  )
}
